export const accountTypes = {
  student: 'student',
  mentor: 'mentor',
};
